import styled from "styled-components";

const shouldForwardProp = (prop, defaultValidatorFn) => {
  if (typeof defaultValidatorFn !== 'function') {
    // console.warn('defaultValidatorFn is not a function');
    return !['positionedSticky', 'isStuck', 'bottom'].includes(prop);
  }
  return !['positionedSticky', 'isStuck', 'bottom'].includes(prop) && defaultValidatorFn(prop);
};
export const stickyStyled = (Component) => styled(Component)
.withConfig({shouldForwardProp});



// const shouldForwardProp = (prop, defaultValidatorFn) => {
//   if (typeof defaultValidatorFn !== 'function') {
//     // console.warn('defaultValidatorFn is not a function');
//     return !['positionedSticky', 'isStuck', 'bottom'].includes(prop);
//   }
//   return !['positionedSticky', 'isStuck', 'bottom'].includes(prop) && defaultValidatorFn(prop);
// };
// const _stickyStyled = (Component) => styled(Component).withConfig({ shouldForwardProp });
// export const stickyStyled = withFilteredProps(_stickyStyled);
// .withConfig({
//   shouldForwardProp: (prop, defaultValidatorFn) => {
//     if (typeof defaultValidatorFn !== 'function') {
//       // console.warn('defaultValidatorFn is not a function');
//       return !['positionedSticky', 'isStuck', 'bottom'].includes(prop);
//     }
//     return !['positionedSticky', 'isStuck', 'bottom'].includes(prop) && defaultValidatorFn(prop);
//   },
// });